import React, { CSSProperties, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { IBottomTab } from './BottomTab';
import { ISimpleImage } from '../../global.d';
import RootStore from '../../store/RootStore';
import { inject, observer } from 'mobx-react';
import JigsawBottom from './JigsawBottom';
import BottomTab from './BottomTab';
import intl from 'react-intl-universal';
import jigsawApi from '../../actions/jigsaw';
import posterApi from '../../actions/poster';
import { direct } from '../../utils/image';
import JigsawPortal from './JigsawPortal';
import PosterPortal from './PosterPortal';
import {setContainer} from '../../utils/dom';
import {IComponentNavigator, IComponentContainer, IComponent} from '../../component.d';
import { IOneGallery } from "../GalleryList/Common";

export const MAX_JIGSAW_NUM = 16;

export const minNumberByType = (type: string) => {
  if (type == "long") {
    return 2;
  }
  if (type == "poster") {
    return 1;
  }

  return 1;
};

export const maxNumberByType = (type: string): number => {
  if (type == "long") {
    return 12;
  }
  if (type == "poster") {
    return 1;
  }
  if (type == 'download') {
    return 50;
  }
  if (type == 'share') {
    return 50;
  }

  return 9;
};

interface AllForBottom extends IBottomTab {
  rootStore?: RootStore;
  navigatorShow: boolean;
}

const AllForBottom = function(props: AllForBottom) {
  const { navigatorShow, component} = props;
  const { galleryStore, uiStore } = props.rootStore!;
  const { jigsaw, setJigsaw } = galleryStore;
  const { bottomShow, jigsawList } = jigsaw;

  const [jigsawUrl, setJigsawUrl] = useState("");
  const [poster, setPoster] = useState([] as IOneGallery[]);

  const processEvent = (event: any) => {
    let { data } = event;

    setJigsaw({
      type: "poster",
      bottomShow: true,
      jigsawList: data.ids,
      from: data.from || "",
    });
    setPoster(data.ids);
  };

  useEffect(() => {
    window.addEventListener("set-jigsaw-data", processEvent);

    return () => {
      window.removeEventListener("set-jigsaw-data", processEvent);
    };
  }, []);

  // console.log(bottomShow, 'bottomShow');
  const onCancel = () => {
    // 清空
    if (jigsaw && jigsaw.from && jigsaw.from == "bigpic") {
      let changeEvent = new Event("CHANGE_BODY_SCROLL");
      changeEvent.data = false;
      window.dispatchEvent(changeEvent);
    }
    setJigsaw({ bottomShow: false, jigsawList: [] });
  };

  const onConfirm = () => {
    const { length } = jigsawList;
    const { type } = jigsaw;
    if (length < minNumberByType(type)) {
      const minKey = type === "download" ? "min-download" : "min-jigsaw";
      uiStore.showAlert({
        content: intl.get(minKey, { num: minNumberByType(jigsaw.type) }),
      });
      return;
    } else if (length > maxNumberByType(type)) {
      const maxKey =
        type === "download" ? "MAX_DOWNLOAD_NUM" : "MAX_JIGSAW_NUM";
      uiStore.showAlert({
        content: intl.get(maxKey, {
          num: maxNumberByType(jigsaw.type),
        }),
      });
      return;
    }

    if (type == "long") {
      uiStore.showToast({
        icon: "loading",
        content: intl.get("Collaging"),
        time: 20000,
      });
      /* 原来的接口调用*/
      jigsawApi
        .create({
          galleryid: window.gallery.id,
          imageids: JSON.stringify(jigsawList.map((it) => it.id)),
        })
        .then((jsonData) => {
          uiStore.hideToast();
          const { data } = jsonData;
          if (data) {
            setJigsawUrl(direct(data));
          }
        })
        .catch((e) => {
          uiStore.hideToast();
          throw e;
        });
    }
    if (jigsaw.type == "poster") {
      setPoster(jigsawList);
    }
    if (jigsaw.type == "download") {
      // 直接调起小程序下载了，代码层无需处理
    }
    if (jigsaw.type == "share") {
      // 根据选择的ids生成分享链接
      console.log(`share`);
    }

    // onCancel();
  };

  if (bottomShow) {
    return (
      <>
        <JigsawBottom
          onCancel={onCancel}
          onConfirm={onConfirm}
          type={jigsaw.type}
          list={jigsawList}
        />
        {/*<JigsawPortal
          url={jigsawUrl}
          onClose={() => {
            setJigsawUrl("");
            onCancel();
          }}
        />*/}
        {
          // 注意，PosterPortal里边会锁定滚动，所以不适合在不需要的场景下渲染出来
          poster?.length && (
            <PosterPortal
              data={poster}
              onClose={() => {
                setPoster([]);
                onCancel();
              }}
            />
          )
        }
      </>
    );
  }


  return navigatorShow ? <BottomTab {...props} component={component} /> : null;
};

export default inject("rootStore")(observer(AllForBottom));
